module.exports = __webpack_public_path__ + "static/media/IMG_4207 - Version 2.2ba2dd37.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/items/IMG_4207 - Version 2.JPG
// module id = 527
// module chunks = 0